import styled from "styled-components/macro";
import { rem } from "polished";

import { colors } from "../../../styles/Styles.variables";

const PageLogoHoltCat = props => (
  <StyledLogo href="https://www.holtcat.com/" {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 214 61">
      <title>HOLTCAT logo</title>
      <rect width="214" height="61" fill="#fff" />
      <rect x="5.13" y="5.03" width="152.81" height="50.94" fill="#ffcd11" />
      <rect x="157.94" y="5.03" width="50.94" height="50.94" />
      <polygon
        points="196.45 42.15 184.56 32.18 172.22 42.15 196.45 42.15"
        fill="#ffcd11"
      />
      <path
        d="M170.13,42.15h-1.52a4.77,4.77,0,0,1-4.92-4.78V23.31c0-2.74,1.7-5,6.18-5h0c4.37,0,6.16,2.26,6.16,5h0v5h-4.89V23.48a1.23,1.23,0,0,0-1.23-1.23,1.19,1.19,0,0,0-1.18,1.23V37a1.19,1.19,0,0,0,1.18,1.23A1.23,1.23,0,0,0,171.14,37V32.2H176v3.5A3,3,0,0,1,175,38.21Zm28.14,0h1.45V23.31h3.39V18.76H190.89v4.55h3.38V38.76Zm-6-5-7.71-6.46-7.4,6,4-17.82H188Zm-6.4-7.6-1.31-6.73-1.32,6.73Zm19.65-8A1.46,1.46,0,1,0,204.06,20,1.45,1.45,0,0,0,205.52,21.46Zm0-.25a1.2,1.2,0,1,1,1.2-1.21A1.21,1.21,0,0,1,205.52,21.21Zm-.08-1.11c.09,0,.18,0,.24.07a.64.64,0,0,1,.1.36c0,.1,0,.21.06.31h.34a2.11,2.11,0,0,1-.1-.5c0-.18-.05-.29-.29-.33h0a.4.4,0,0,0,.35-.4c0-.39-.33-.47-.64-.47H205v1.71h.26V20.1Zm-.23-.27v-.44h.32c.22,0,.28.07.28.2s-.06.23-.31.24Z"
        fill="#fff"
      />
      <path d="M63.35,20.41,59.33,40h-10l1.55-7.57H42.13L40.58,40h-10l4-19.57h10l-1.47,7.14h8.72l1.47-7.14ZM106.7,35.14l3-14.73h-10L95.68,40h19l1-4.85Zm38.45-14.73H115.56l-1,4.85h9.75L121.3,40h10l3-14.72h9.79ZM81.59,20c-9.3,0-17.85,4.58-19.1,10.24S67.76,40.5,77.06,40.5,94.9,35.91,96.15,30.25,90.88,20,81.59,20Zm4.49,10.24c-.5,3.26-3.94,5.89-7.68,5.89S72,33.51,72.53,30.25s4-5.88,7.69-5.88S86.58,27,86.08,30.25Zm53.65,8.58a1.35,1.35,0,1,0-1.34,1.35A1.34,1.34,0,0,0,139.73,38.83Zm-3,0a1.66,1.66,0,1,1,1.66,1.66A1.65,1.65,0,0,1,136.73,38.83Zm2.48.91h-.41l-.39-.76h-.35v.76h-.35V38h.86a.93.93,0,0,1,.49.09.5.5,0,0,1,.21.46c0,.32-.18.46-.49.48Zm-.63-1c.2,0,.34,0,.34-.26s-.26-.24-.43-.24h-.43v.5Z" />
    </svg>
  </StyledLogo>
);

const StyledLogo = styled.a`
  color: ${colors.white};
  display: block;
  outline: ${rem("1px")} dotted transparent;
  text-decoration: none;

  &:focus {
    outline-color: ${colors.white};
  }

  svg {
    display: block;
  }
`;

export default PageLogoHoltCat;
